import React, { useState, useEffect } from 'react';
import './BuildInfo.css';
import ChampionRuneBuild from '../../NewWebSocket/components/ChampionInfo/ChampionRuneBuild';
import ChampionItemBuild from '../../NewWebSocket/components/ChampionInfo/ChampionItemBuild';
import ChampionSummonerSpells from '../../NewWebSocket/components/ChampionInfo/ChampionSummonerSpells';
import ChampionSkillPriority from '../../NewWebSocket/components/ChampionInfo/ChampionSkillPriority';
import ChampionSkillOrder from '../../NewWebSocket/components/ChampionInfo/ChampionSkillOrder';
import DataService from '../../XXX/DataService';

const ROLE_ORDER = ['TOP', 'JUNGLE', 'MIDDLE', 'BOTTOM', 'UTILITY'] as const;
const ROLE_LABELS: Record<string, string> = {
  TOP: 'Top',
  JUNGLE: 'Jungle',
  MIDDLE: 'Mid',
  BOTTOM: 'Bot',
  UTILITY: 'Support',
};
const ROLE_ICONS: Record<string, string> = {
  TOP: '/Images/top_icon.png',
  JUNGLE: '/Images/jgl_icon.png',
  MIDDLE: '/Images/mid_icon.png',
  BOTTOM: '/Images/bot_icon.png',
  UTILITY: '/Images/sup_icon.png',
};

interface BuildInfoProps {
  championName: string;
  championLane?: string;
}

const BuildInfo: React.FC<BuildInfoProps> = ({ 
  championName,
  championLane,
}) => {
  const [patch, setPatch] = useState<string>('');

  useEffect(() => {
    DataService.fetchLatestVersion().then((version) => {
      // version is like "15.9.1" — extract "15.9" as the patch
      const parts = version.split('.');
      setPatch(`${parts[0]}.${parts[1]}`);
    });
  }, []);

  return (
    <div className="champion-content-layout">
    {/* Role Bar */}
    <div className="role-bar">
      {ROLE_ORDER.map((role) => (
        <div
          key={role}
          className={`role-bar-item ${championLane === role ? 'active' : ''}`}
        >
          <img
            src={ROLE_ICONS[role]}
            alt={ROLE_LABELS[role]}
            className="role-bar-icon"
          />
        </div>
      ))}
      {patch && (
        <>
          <div className="role-bar-divider" />
          <div className="role-bar-patch">Patch {patch}</div>
        </>
      )}
    </div>

    {/* Left column - Runes */}
    <div className="champion-left-column">
      <div className="champion-runes-section">
        <ChampionRuneBuild championName={championName} />
      </div>

      <div className="champion-summoner-spells-section">
        <h2 className="build-info-title">Summoner Spells</h2>
        <ChampionSummonerSpells championName={championName} />
      </div>
    </div>
    
    {/* Right column - Items and Skills */}
    <div className="champion-right-column">
      <div className="champion-items-section">
        <h2 className="build-info-title">Items</h2>
        <ChampionItemBuild championName={championName} championLane={championLane} />
      </div>

    
      
      <div className="champion-skills-section">
        {/* Skill Priority */}
       { <div className="champion-skill-priority-container">
          <h2 className="build-info-title">Skill Priority</h2>
          <ChampionSkillPriority championName={championName} />
        </div>}
        
        {/* Skill Order */}
       { <div className="champion-skill-order-container">
          <h2 className="build-info-title">Skill Order</h2>
          <ChampionSkillOrder championName={championName} />
        </div>}
      </div>
    </div>
  </div>
  );
};

export default BuildInfo; 